/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Own_AccessInputs */

const en_error_own_access = /** @type {(inputs: Error_Own_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You cannot change your own access: ask another administrator.`)
};

/**
* | output |
* | --- |
* | "You cannot change your own access: ask another administrator." |
*
* @param {Error_Own_AccessInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_own_access = /** @type {((inputs?: Error_Own_AccessInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Own_AccessInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_own_access(inputs)
});